/**
 * Calculator API client.
 *
 * Public endpoints — no auth required. The dynamic /tools/{slug} page
 * uses these helpers to drive the entire calculator flow.
 */
import { api } from "./api";

export async function fetchCalculator(slug) {
    const r = await api.get(`/calculators/${slug}`);
    return r.data?.calculator;
}

export async function fetchCalculatorCatalog(category = null) {
    const r = await api.get("/calculators", {
        params: category ? { category } : {},
    });
    return r.data;
}

export async function fetchCalculatorCategories() {
    const r = await api.get("/calculators/categories");
    return r.data?.categories || [];
}

export async function runCalculator(slug, inputs) {
    const r = await api.post(`/calculators/${slug}/calculate`, { inputs });
    return r.data?.result;
}

export async function captureCalculatorLead({
    slug, email, inputs, result, source = "result",
}) {
    const r = await api.post(`/calculators/${slug}/lead`, {
        email,
        inputs,
        result_summary: result?.summary_text,
        severity_level: result?.severity?.level,
        negotiation_level: result?.negotiation?.level,
        cost_low: result?.cost_range_usd?.low,
        cost_high: result?.cost_range_usd?.high,
        opt_in: true,
        source,
    });
    return r.data;
}

/** Triggers a download of the result PDF in the browser. */
export async function downloadCalculatorPdf(slug, inputs) {
    const r = await api.post(`/calculators/${slug}/pdf`, { inputs }, {
        responseType: "blob",
    });
    const blob = new Blob([r.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `buyers-leverage-${slug}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
